var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { addErrorToast, addSuccessToast } from "module/main/store/toast/reducer";
import { selectApiKeys, selectSubscription, selectUserInfo, } from "module/main/store/auth/selectors";
import { callGetApiKeys } from "module/main/store/auth/thunk";
import { useAppDispatch } from "module/main/store/hooks";
import SideNav from "../HomePage/components/SideNav";
import { createFileImportAction, downloadFileImportActionExport, exportFileImportAction, listFileImports, pauseFileImportAction, resumeFileImportAction, retryFailedFileImportAction, runFileImportAction, } from "./api";
import BumpyFileImporter from "./BumpyFileImporter";
import { parseRanges } from "./bumpy";
import { FilesList } from "./Components/FilesList";
import { ImportSummary } from "./Components/ImportSummary";
import { RerunActionModal } from "./Components/RerunActionModal";
import { WarningBox } from "./Components/WarningBox";
import { apiKeyLabel, endpointLabel, endpoints, estimateRows, fileImportHasRunningishAction, getUsageWarning, hasDncAddon, } from "./util";
var pageSize = 25;
var FileImports = function () {
    var _a, _b, _c, _d, _e;
    var dispatch = useAppDispatch();
    var userInfo = useSelector(selectUserInfo);
    var apiKeys = useSelector(selectApiKeys);
    var subscription = useSelector(selectSubscription);
    var _f = useState([]), imports = _f[0], setImports = _f[1];
    var _g = useState(null), activeImport = _g[0], setActiveImport = _g[1];
    var _h = useState("workbench"), activeTab = _h[0], setActiveTab = _h[1];
    var _j = useState(false), hasMoreImports = _j[0], setHasMoreImports = _j[1];
    var _k = useState("PROPERTY"), selectedEndpoint = _k[0], setSelectedEndpoint = _k[1];
    var _l = useState(""), selectedApiKey = _l[0], setSelectedApiKey = _l[1];
    var _m = useState("all"), rowMode = _m[0], setRowMode = _m[1];
    var _o = useState(""), rangeText = _o[0], setRangeText = _o[1];
    var _p = useState(false), isStarting = _p[0], setIsStarting = _p[1];
    var _q = useState(false), isRunning = _q[0], setIsRunning = _q[1];
    var _r = useState(null), error = _r[0], setError = _r[1];
    var _s = useState(null), rerunAction = _s[0], setRerunAction = _s[1];
    var _t = useState({}), loadingActions = _t[0], setLoadingActions = _t[1];
    var bumpyImporterRef = useRef(null);
    var accountId = String((_b = (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.accountId) !== null && _a !== void 0 ? _a : userInfo === null || userInfo === void 0 ? void 0 : userInfo.accountName) !== null && _b !== void 0 ? _b : "unknown");
    var userId = String((_c = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) !== null && _c !== void 0 ? _c : "unknown");
    var objectPrefix = (_d = userInfo === null || userInfo === void 0 ? void 0 : userInfo.storagePrefix) !== null && _d !== void 0 ? _d : null;
    var refreshImports = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var existing;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, listFileImports(0, pageSize)];
                case 1:
                    existing = _a.sent();
                    setImports(existing);
                    setHasMoreImports(existing.length === pageSize);
                    setActiveImport(function (current) {
                        var _a, _b;
                        if (!current)
                            return (_a = existing[0]) !== null && _a !== void 0 ? _a : null;
                        return (_b = existing.find(function (fileImport) { return fileImport.id === current.id; })) !== null && _b !== void 0 ? _b : current;
                    });
                    return [2 /*return*/];
            }
        });
    }); }, []);
    function loadMoreImports() {
        return __awaiter(this, void 0, void 0, function () {
            var more;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, listFileImports(imports.length, pageSize)];
                    case 1:
                        more = _a.sent();
                        setImports(function (current) { return __spreadArray(__spreadArray([], current, true), more, true); });
                        setHasMoreImports(more.length === pageSize);
                        return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        void refreshImports().catch(function (e) { return setError(String(e)); });
        dispatch(callGetApiKeys());
    }, [dispatch, refreshImports]);
    useEffect(function () {
        var shouldPoll = imports.some(fileImportHasRunningishAction);
        if (!shouldPoll)
            return;
        var interval = window.setInterval(function () {
            void refreshImports().catch(function (e) { return setError(String(e)); });
        }, 5000);
        return function () { return window.clearInterval(interval); };
    }, [imports, refreshImports]);
    useEffect(function () {
        var _a, _b, _c;
        if (selectedApiKey || !(apiKeys === null || apiKeys === void 0 ? void 0 : apiKeys.length))
            return;
        var liveKey = apiKeys.find(function (key) { return key.isActive && key.isLive; });
        var testKey = apiKeys.find(function (key) { return key.isActive && String(key.keyType).toUpperCase() === "TEST"; });
        setSelectedApiKey((_c = (_b = ((_a = liveKey !== null && liveKey !== void 0 ? liveKey : testKey) !== null && _a !== void 0 ? _a : apiKeys[0])) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : "");
    }, [apiKeys, selectedApiKey]);
    var rowScope = useMemo(function () {
        if (rowMode === "all")
            return { mode: "all" };
        return { mode: "ranges", ranges: parseRanges(rangeText) };
    }, [rangeText, rowMode]);
    var selectedApiKeyInfo = useMemo(function () { var _a; return (_a = apiKeys === null || apiKeys === void 0 ? void 0 : apiKeys.find(function (apiKey) { return apiKey.id === selectedApiKey; })) !== null && _a !== void 0 ? _a : null; }, [apiKeys, selectedApiKey]);
    var estimatedRows = estimateRows(activeImport, rowScope);
    var activeEndpointAction = (_e = activeImport === null || activeImport === void 0 ? void 0 : activeImport.actions) === null || _e === void 0 ? void 0 : _e.find(function (action) { return action.endpoint === selectedEndpoint; });
    var dncBlocked = selectedEndpoint === "DNC" && !hasDncAddon(subscription);
    var usageWarning = getUsageWarning({
        activeImport: activeImport,
        estimatedRows: estimatedRows,
        selectedApiKeyInfo: selectedApiKeyInfo,
        autoRechargeBlockId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.autoRechargeBlockId,
        hasSubscription: !!subscription,
    });
    function startImport() {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!userInfo)
                            return [2 /*return*/];
                        setError(null);
                        setActiveImport(null);
                        setActiveTab("workbench");
                        return [4 /*yield*/, ((_a = bumpyImporterRef.current) === null || _a === void 0 ? void 0 : _a.openPortal())];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function queueSelectedAction() {
        return __awaiter(this, void 0, void 0, function () {
            var action, e_1, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!activeImport)
                            return [2 /*return*/];
                        if (!selectedApiKey) {
                            setError("Please select an API key first.");
                            return [2 /*return*/];
                        }
                        if (dncBlocked) {
                            setError("DNC Status requires the DNC add-on before it can be run.");
                            return [2 /*return*/];
                        }
                        setError(null);
                        setIsRunning(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 7]);
                        return [4 /*yield*/, createFileImportAction(activeImport.id, {
                                endpoint: selectedEndpoint,
                                apiKeyId: selectedApiKey,
                                rowScope: rowScope,
                            })];
                    case 2:
                        action = _a.sent();
                        return [4 /*yield*/, runFileImportAction(action.id)];
                    case 3:
                        _a.sent();
                        dispatch(addSuccessToast("Action queued."));
                        return [4 /*yield*/, refreshImports()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        e_1 = _a.sent();
                        message = e_1 instanceof Error ? e_1.message : String(e_1);
                        setError(message);
                        dispatch(addErrorToast(message));
                        return [3 /*break*/, 7];
                    case 6:
                        setIsRunning(false);
                        setRerunAction(null);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    function runAction() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!activeImport)
                            return [2 /*return*/];
                        if ((activeEndpointAction === null || activeEndpointAction === void 0 ? void 0 : activeEndpointAction.status) === "QUEUED" || (activeEndpointAction === null || activeEndpointAction === void 0 ? void 0 : activeEndpointAction.status) === "RUNNING") {
                            setError("This action is already running for this file.");
                            return [2 /*return*/];
                        }
                        if ((activeEndpointAction === null || activeEndpointAction === void 0 ? void 0 : activeEndpointAction.status) === "PAUSED") {
                            setError("Resume the paused action instead of starting a new one.");
                            return [2 /*return*/];
                        }
                        if (activeEndpointAction && activeEndpointAction.totalRows > 0) {
                            setRerunAction(activeEndpointAction);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, queueSelectedAction()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function performAction(actionId_1, operation_1, updater_1, successMessage_1) {
        return __awaiter(this, arguments, void 0, function (actionId, operation, updater, successMessage, refresh) {
            var e_2, message;
            if (refresh === void 0) { refresh = true; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setError(null);
                        setLoadingActions(function (current) {
                            var _a;
                            return (__assign(__assign({}, current), (_a = {}, _a[actionId] = operation, _a)));
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 7]);
                        return [4 /*yield*/, updater(actionId)];
                    case 2:
                        _a.sent();
                        dispatch(addSuccessToast(successMessage));
                        if (!refresh) return [3 /*break*/, 4];
                        return [4 /*yield*/, refreshImports()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_2 = _a.sent();
                        message = e_2 instanceof Error ? e_2.message : String(e_2);
                        setError(message);
                        dispatch(addErrorToast(message));
                        return [3 /*break*/, 7];
                    case 6:
                        setLoadingActions(function (current) {
                            var next = __assign({}, current);
                            delete next[actionId];
                            return next;
                        });
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    function exportAction(actionId) {
        dispatch(addSuccessToast("Export queued. It may take a moment to generate."));
        void performAction(actionId, "export", exportFileImportAction, "Export generation started.");
    }
    return (_jsxs("section", { className: "flex h-full bg-appBg", children: [_jsx(SideNav, {}), _jsx(BumpyFileImporter, { ref: bumpyImporterRef, accountId: accountId, userId: userId, objectPrefix: objectPrefix, onStart: function () { return setIsStarting(true); }, onDone: function () { return setIsStarting(false); }, onError: function (message) {
                    setError(message);
                    dispatch(addErrorToast(message));
                }, onImported: function (fileImport) {
                    var _a;
                    setActiveImport(fileImport);
                    setSelectedEndpoint((_a = fileImport.endpointRecommendation) !== null && _a !== void 0 ? _a : "PROPERTY");
                    setActiveTab("workbench");
                    dispatch(addSuccessToast("Import ready."));
                    void refreshImports();
                } }), _jsx(RerunActionModal, { action: rerunAction, isLoading: isRunning, onClose: function () { return setRerunAction(null); }, onConfirm: function () { return void queueSelectedAction(); } }), _jsx("div", { className: "min-w-0 flex-1 overflow-auto", children: _jsxs("div", { className: "mx-auto w-full max-w-7xl px-8 py-8", children: [_jsxs("div", { className: "mb-6 flex items-start justify-between gap-4 border-b border-sherpaChocoCream pb-5", children: [_jsxs("div", { children: [_jsx("p", { className: "mb-2 text-xs font-extrabold uppercase tracking-[0.18em] text-primary", children: "Imports" }), _jsx("h1", { className: "text-3xl font-extrabold text-ink", children: "File imports" }), _jsx("p", { className: "mt-2 text-sm text-mutedBlue", children: "Import a file, pick an endpoint, then queue an action." })] }), _jsx("button", { type: "button", className: "rounded-lg bg-primary px-5 py-3 text-sm font-extrabold text-white shadow-sm disabled:opacity-60", onClick: startImport, disabled: isStarting, children: isStarting ? "Starting…" : "+ New import" })] }), _jsxs("div", { className: "mb-5 inline-flex rounded-xl bg-sherpaTeaCream p-1 text-sm font-extrabold", children: [_jsx("button", { type: "button", className: "rounded-lg px-4 py-2 ".concat(activeTab === "workbench" ? "bg-primary text-white" : "text-slate"), onClick: function () { return setActiveTab("workbench"); }, children: "Workbench" }), _jsx("button", { type: "button", className: "rounded-lg px-4 py-2 ".concat(activeTab === "files" ? "bg-primary text-white" : "text-slate"), onClick: function () { return setActiveTab("files"); }, children: "Files" })] }), error ? (_jsx("div", { className: "mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-700", children: error })) : null, activeTab === "workbench" ? (_jsxs("div", { className: "grid gap-6 xl:grid-cols-[1fr_390px]", children: [_jsx("section", { className: "rounded-2xl border border-sherpaChocoCream bg-white p-6 shadow-sm", children: activeImport ? (_jsx(ImportSummary, { fileImport: activeImport, loadingActions: loadingActions, onPause: function (actionId) {
                                            return void performAction(actionId, "pause", pauseFileImportAction, "Action paused.");
                                        }, onResume: function (actionId) {
                                            return void performAction(actionId, "resume", resumeFileImportAction, "Action resumed.");
                                        }, onRetryFailed: function (actionId) {
                                            return void performAction(actionId, "retry", retryFailedFileImportAction, "Failed rows queued for retry.");
                                        }, onExport: exportAction, onDownload: function (actionId) {
                                            return void performAction(actionId, "download", downloadFileImportActionExport, "Export downloaded.", false);
                                        } })) : (_jsx("div", { className: "grid min-h-[280px] place-items-center rounded-xl border border-dashed border-blue-200 bg-blue-50/50 p-8 text-center", children: _jsxs("div", { children: [_jsx("h2", { className: "text-xl font-extrabold text-ink", children: "Start a new import" }), _jsx("p", { className: "mt-2 text-sm text-mutedBlue", children: "Upload a file, map columns, then use it here." }), _jsx("button", { type: "button", className: "mt-5 rounded-lg bg-primary px-5 py-3 text-sm font-extrabold text-white disabled:opacity-60", onClick: startImport, disabled: isStarting, children: isStarting ? "Starting…" : "Choose file" })] }) })) }), _jsxs("aside", { className: "rounded-2xl border border-sherpaChocoCream bg-white p-6 shadow-sm", children: [_jsx("p", { className: "mb-2 text-xs font-extrabold uppercase tracking-[0.18em] text-primary", children: "Configure" }), _jsx("h2", { className: "text-xl font-extrabold text-ink", children: "Endpoint & rows" }), (activeImport === null || activeImport === void 0 ? void 0 : activeImport.endpointRecommendation) ? (_jsxs("div", { className: "mt-4 rounded-xl bg-sherpaTeaCream px-3 py-2 text-sm font-semibold text-primary", children: ["Recommended: ", endpointLabel(activeImport.endpointRecommendation)] })) : null, _jsx("label", { className: "mt-6 block text-xs font-extrabold uppercase tracking-[0.16em] text-slate", children: "API key" }), _jsxs("select", { className: "mt-2 w-full rounded-xl border border-sherpaChocoCream bg-white px-4 py-3 text-sm font-bold text-ink", value: selectedApiKey, onChange: function (event) { return setSelectedApiKey(event.target.value); }, children: [_jsx("option", { value: "", children: "Select API key" }), (apiKeys !== null && apiKeys !== void 0 ? apiKeys : []).map(function (apiKey) { return (_jsx("option", { value: apiKey.id, children: apiKeyLabel(apiKey) }, apiKey.id)); })] }), _jsx("label", { className: "mt-6 block text-xs font-extrabold uppercase tracking-[0.16em] text-slate", children: "Endpoint" }), _jsx("select", { className: "mt-2 w-full rounded-xl border border-sherpaChocoCream bg-white px-4 py-3 text-sm font-bold text-ink", value: selectedEndpoint, onChange: function (event) {
                                                return setSelectedEndpoint(event.target.value);
                                            }, children: endpoints.map(function (endpoint) { return (_jsx("option", { value: endpoint.value, children: endpoint.label }, endpoint.value)); }) }), dncBlocked ? (_jsxs(WarningBox, { children: ["DNC Status requires the DNC add-on. Add it from", " ", _jsx("a", { className: "font-extrabold underline", href: "/account#dnc-addons", children: "Billing" }), " ", "before running this action."] })) : null, _jsx("label", { className: "mt-6 block text-xs font-extrabold uppercase tracking-[0.16em] text-slate", children: "Run on" }), _jsxs("div", { className: "mt-2 grid grid-cols-2 rounded-xl bg-sherpaTeaCream p-1 text-sm font-extrabold", children: [_jsx("button", { type: "button", className: "rounded-lg px-3 py-2 ".concat(rowMode === "all" ? "bg-primary text-white" : "text-slate"), onClick: function () { return setRowMode("all"); }, children: "All rows" }), _jsx("button", { type: "button", className: "rounded-lg px-3 py-2 ".concat(rowMode === "ranges" ? "bg-primary text-white" : "text-slate"), onClick: function () { return setRowMode("ranges"); }, children: "Ranges" })] }), rowMode === "ranges" ? (_jsx("input", { className: "mt-3 w-full rounded-xl border border-sherpaChocoCream px-4 py-3 text-sm", value: rangeText, onChange: function (event) { return setRangeText(event.target.value); }, placeholder: "1-50, 75, 90-120" })) : null, usageWarning ? _jsx(WarningBox, { children: usageWarning }) : null, _jsx("div", { className: "my-6 border-t border-sherpaChocoCream" }), _jsx("button", { type: "button", className: "w-full rounded-lg bg-primary px-5 py-3 text-sm font-extrabold text-white shadow-sm disabled:opacity-60", disabled: !activeImport || !selectedApiKey || isRunning || dncBlocked, onClick: function () { return void runAction(); }, children: isRunning ? "Queueing…" : "Run action" })] })] })) : (_jsx(FilesList, { imports: imports, hasMore: hasMoreImports, onLoadMore: loadMoreImports, onSelect: function (fileImport) {
                                setActiveImport(fileImport);
                                if (fileImport.endpointRecommendation)
                                    setSelectedEndpoint(fileImport.endpointRecommendation);
                                setActiveTab("workbench");
                            } }))] }) })] }));
};
export default FileImports;
